import {
    Popover as AriaPopover,
    type PopoverProps as AriaPopoverProps,
    composeRenderProps,
} from 'react-aria-components';

import { classnames } from '@/utils/classnames.ts';

// The box that menus, select options and pickers open in.
const Popover = ({ className, ...props }: AriaPopoverProps) => (
    <AriaPopover
        {...props}
        className={composeRenderProps(className, (className) =>
            classnames('overflow-auto rounded-xl border border-border bg-surface p-1 shadow-lg outline-none', className)
        )}
    />
);

// Lists of options are at least as wide as their field, but wider when the options need it (narrow filter selects).
export const listPopoverClassName = 'max-h-80 min-w-(--trigger-width) max-w-[min(28rem,calc(100vw-2rem))]';

export default Popover;
